import { toast } from "react-toastify";

import { get, isMockMode, simulateDelay } from "../api";

const mapPermsToOrgs = (data) => {
	data.orgs = data.orgsAndPermissions.map(({ org, permissions }) => {
		try {
			org.customData = JSON.parse(org.customData) || {};
		} catch (e) {
			toast.error(
				`Something's gone wrong with the custom data for ${org.name} - ${org.id}`
			);
			org.customData = {};
		}
		return {
			...org,
			permissions,
		};
	});
	return data;
};

export const getUserMetadata = (includeOrgAvatars = true) => {
	if (isMockMode()) {
		const testData = {
			// userProfile: {
			// 	avatar_Base64: null,
			// 	email: "test.mctestie@mgaol.abc",
			// 	firstName: "Test",
			// 	lastName: "McTestie",
			// },
			orgsAndPermissions: [
				{
					org: {
						description: "Boss hounding since 2015",
						avatar_Base64:
							"data:image/png;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=",
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					permissions: {
						isOrgAdmin: true,
						isDeveloper: false,
						isBusinessManager: false,
						isSubManager: false,
						isTechSupport: false,
						isProductOwnerEnabled: true,
						isServiceOwnerEnabled: true,
					},
				},
				{
					org: {
						description:
							"If the bells 'aint ringin, something something something",
						avatar_Base64:
							"data:image/png;base64,R0lGODlhAQABAIAAAP///wAAACwAAAAAAQABAAACAkQBADs=",
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					permissions: {
						isOrgAdmin: true,
						isDeveloper: false,
						isBusinessManager: false,
						isSubManager: false,
						isTechSupport: false,
						isProductOwnerEnabled: true,
						isServiceOwnerEnabled: false,
					},
				},
			],
		};
		return simulateDelay(50, () => mapPermsToOrgs(testData));
	}

	return get(
		`Orgs/GetUserMetadata?includeOrgAvatars=${includeOrgAvatars}`
	).then(mapPermsToOrgs);
};
